<template>
  <sideNav :page-title="pageTitle"></sideNav>
  <div class="ld-panel-title">
    <h2 class="back-btn">更换客服</h2>
  </div>
  <div class="ld-panel-main">
    <el-alert title="温馨提示：为了能更好的为您服务，在您选择更换您的客服经理后，我们会对您进行回访，以便提高我们的客户服务水平，今后您能享受到更完善的客户服务。" type="warning" show-icon :closable="false" />
    <el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth" class="form-main">
      <el-form-item label="用户名">
        <el-input v-model="userName" disabled />
      </el-form-item>
      <el-form-item label="当前的客户经理">
        <el-input v-model="kefuName" disabled />
      </el-form-item>
      <el-form-item label="新的客户经理" prop="customerServiceId">
        <el-select v-model="groupForm.customerServiceId" placeholder="请选择新的客户经理">
          <el-option v-for="item in kefuListOptions" :key="item.csId" :value="item.csId" :label="item.csName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="更换原因" prop="changeWhy">
        <ul class="ul-changeWhy">
          <li :class="{ 'active': groupForm.changeWhy.includes('经常不在线') }" @click="changeWhyReason('经常不在线')">经常不在线</li>
          <li :class="{ 'active': groupForm.changeWhy.includes('服务态度差') }" @click="changeWhyReason('服务态度差')">服务态度差</li>
          <li :class="{ 'active': groupForm.changeWhy.includes('无服务人员') }" @click="changeWhyReason('无服务人员')">无服务人员</li>
          <li :class="{ 'active': groupForm.changeWhy.includes('选错客服') }" @click="changeWhyReason('选错客服')">选错客服</li>
        </ul>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="groupForm.remark" autocomplete="off" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import sideNav from '../../components/sideNav.vue'
import {customerServiceInfo, customerServiceChange} from "@/api/account";
import {ElMessage, ElMessageBox} from "element-plus";
import {inject, onMounted, reactive, ref} from "vue";

const wwwDomain = inject('domain');
const pageTitle = 'account';
const formLabelWidth = ref('160px');
const userName = ref('');
const kefuName = ref('');
const changeWhy = ref([]);
const kefuListOptions = ref();
const ruleFormRef = ref(null);
const groupForm = ref({customerServiceId:'',changeWhy:[],remark:''});
const rules = reactive({
  customerServiceId: [
    { required: true, message: '请选择新的客户经理', trigger: 'blur' }
  ],
  changeWhy: [
    { required: true, message: '请选择更换原因', trigger: 'blur' }
  ]
});

const getUserInfoF = () => {
  customerServiceInfo().then((res) => {
    if(res.code === 200){
      userName.value = res.data.userName;
      kefuName.value = res.data.customerServiceName;
      kefuListOptions.value = res.data.CsList;
    }
  })
};
const changeWhyReason = (key) => {
  const index = changeWhy.value.indexOf(key);
  if (index === -1) {
    changeWhy.value.push(key);
  } else {
    changeWhy.value.splice(index, 1);
  }
  groupForm.value.changeWhy = [...changeWhy.value]; // 为了触发表单验证
};
const submitForm = () => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      const param = groupForm.value;
      param['changeWhy'] = changeWhy.value;
      customerServiceChange(param).then((res) => {
        if(res.code === 200){
          ElMessage({
            offset:70,
            message: res.msg,
            type: 'success'
          })
          // location.reload()
          // ElMessageBox.confirm('更换客服请求已提交，请等待管理员确认。', '操作成功', {
          //   confirmButtonText: '确认',
          //   type: 'success',
          // }).then(() => {
          //   location.reload()
          //   // window.location.href = wwwDomain + '/user';
          // }).catch(() => {
          // });
        }
      })
    } else {
      return false;
    }
  });
};

onMounted(() => {
  getUserInfoF()
});

</script>

<style scoped lang="scss">
.ul-changeWhy{
  li{
    float: left;
    border: 1px solid #ddd;
    height: 30px;
    line-height: 30px;
    position: relative;
    padding: 0 20px;
    margin: 0 10px 5px 0;
    width: 162px;
    cursor: pointer;
  }
  .active{color: #015BFE;border-color: #015BFE;background: url(../../assets/images/active.png) right bottom no-repeat;}
}
.tip{color: #666; font-size: 13px; margin-left: 10px;}
</style>